import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/home/HomeView.vue";
import BlankLayout from "@/layouts/BlankLayout.vue";
import AdminHomeView from "@/views/admin/AdminHomeView.vue";
import ServiceHallLayout from "@/views/serviceHall/layout/ServiceHallLayout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: HomeView,
    redirect: "/home",
    meta: { title: "首页", keepAlive: true },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    redirect: "/home/message/index",
    meta: { title: "首页", keepAlive: true },
    children: [
      {
        path: "message/index",
        name: "MessageIndex",
        component: () => import("@/views/home/messenger/MessageIndex.vue"),
        meta: { title: "消息", keepAlive: true },
      },
      {
        path: "contacts/index",
        name: "ContactsIndex",
        component: () => import("@/views/home/contacts/ContactsIndex.vue"),
        meta: { title: "通讯录", keepAlive: true },
      },
      {
        path: "workplace/index",
        name: "WorkHomeIndex",
        component: () => import("@/views/home/workplace/WorkplaceHomeView.vue"),
        meta: { title: "工作台", keepAlive: true, type: "app" },
      },
      {
        path: "person/index",
        name: "PersonIndex",
        component: () => import("@/views/home/person/PersonIndex.vue"),
        meta: { title: "个人中心", keepAlive: true },
      },
      {
        path: "navigation/index",
        name: "NavigationIndex",
        component: () => import("@/views/home/navigation/NavigationView.vue"),
        meta: { title: "导航栏", keepAlive: true },
      },
    ],
  },
  {
    path: "/admin",
    name: "AdminIndex",
    component: AdminHomeView,
    redirect: "/admin/app/index",
    meta: { requiresAdmin: true },
    children: [
      {
        path: "home",
        name: "AdminHome",
        redirect: "/admin/home/index",
        component: BlankLayout,
        meta: { title: "首页", keepAlive: true, requiresAdmin: true },
        children: [
          {
            path: "index",
            name: "AdminHomeIndex",
            component: () => import("@/views/admin/home/AdminHome.vue"),
            meta: { title: "首页", keepAlive: true },
          }
        ],
      },
      {
        path: "contacts/index",
        name: "ContactsAdminIndex",
        component: () => import("@/views/admin/contacts/ContactsAdminIndex.vue"),
        meta: { title: "通讯录", keepAlive: true },
        children: [
          {
            path: "org",
            name: "ContactsOrg",
            component: () => import("@/views/admin/contacts/OrgIndex.vue"),
            meta: { title: "组织机构", keepAlive: true },
          },
          {
            path: "emp",
            name: "ContactsEmp",
            component: () => import("@/views/admin/contacts/EmployeeIndex.vue"),
            meta: { title: "教职工管理", keepAlive: true },
          },
          {
            path: "group",
            name: "ContactsGroup",
            component: () => import("@/views/admin/contacts/OrgIndex.vue"),
            meta: { title: "群组管理", keepAlive: true },
          },
          {
            path: "adminClass",
            name: "ContactsAdminClass",
            component: () => import("@/views/admin/contacts/ClassIndex.vue"),
            meta: { title: "行政班管理", keepAlive: true },
          },
          {
            path: "student",
            name: "ContactsStudent",
            component: () => import("@/views/admin/contacts/StudentIndex.vue"),
            meta: { title: "学生管理", keepAlive: true },
          },
        ],
      },
      {
        path: "app",
        name: "AppCenter",
        redirect: "/admin/app/index",
        component: BlankLayout,
        meta: { title: "应用中心", keepAlive: true },
        children: [
          {
            path: "index",
            name: "AppAdminIndex",
            component: () => import("@/views/admin/app/AdminAppView.vue"),
            meta: { title: "应用中心", keepAlive: true },
          }
        ],
      },
      {
        path: "navigation",
        name: "NavigationManage",
        redirect: "/admin/navigation/index",
        component: BlankLayout,
        meta: { title: "导航页管理", keepAlive: true },
        children: [
          {
            path: "index",
            name: "NavigationAdminIndex",
            component: () => import("@/views/admin/navigation/NavigationAdminIndex.vue"),
            meta: { title: "导航页管理", keepAlive: true },
          }
        ],
      },
      {
        path: "company",
        name: "CompanyAdminView",
        component: () => import("@/views/admin/company/CompanyAdminView.vue"),
        meta: { title: "配置中心", keepAlive: true },
        redirect: "/admin/company/config",
        children: [
          {
            path: "config",
            name: "CompanyConfig",
            component: () => import("@/views/admin/company/CompanyConfig.vue"),
            meta: { title: "单位信息", keepAlive: true },
          },
          {
            path: "admin/user",
            name: "AdminUser",
            component: () => import("@/views/admin/company/admin/AdminUser.vue"),
            meta: { title: "管理员权限", keepAlive: true },
          },
          {
            path: "admin/group",
            name: "AdminGroup",
            component: () => import("@/views/admin/company/admin/AdminGroup.vue"),
            meta: { title: "管理员组管理", keepAlive: true },
          },
          {
            path: "role",
            name: "RoleList",
            component: () => import("@/views/admin/company/role/RoleList.vue"),
            meta: { title: "角色管理", keepAlive: true },
          }
        ],
      },
    ],
  },
  {
    path: '/hall',
    component: ServiceHallLayout,
    redirect: '/service/hall',
    children: [
      {
        path: '/service/hall',
        name: 'serviceHall',
        component: () => import('@/views/serviceHall/ServiceHallIndex.vue')
      }
    ]
  },
  {
    path: '/ehall',
    component: BlankLayout,
    redirect: '/service/ehall',
    children: [
      {
        path: '/service/ehall',
        name: 'Ehall',
        component: () => import('@/views/ehall/index.vue')
      }
    ]
  },
  {
    path: '/exception',
    name: 'exception',
    redirect: '/exception/403',
    component: BlankLayout,
    meta: { title: 'menu.exception', icon: 'warning', permission: ['exception'] },
    children: [
      {
        path: '/exception/403',
        name: 'ExceptionPage403',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page403.vue'),
        meta: { title: '403', permission: ['exception'] }
      },
      {
        path: '/exception/404',
        name: 'ExceptionPage404',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page404.vue'),
        meta: { title: '404', permission: ['exception'] }
      },
      {
        path: '/exception/500',
        name: 'ExceptionPage500',
        component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/Page500.vue'),
        meta: { title: '500', permission: ['exception'] }
      }
    ]
  }
];

const createRouter = () =>
  new VueRouter({
    base: process.env.VUE_APP_BASE_PATH + 'frontend/',
    mode: "history",
    routes,
  });

const router = createRouter();

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(() => {
  });
};

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export function get404Router() {
  return {
    path: '*',
    redirect: '/exception/404',
    hidden: true
  }
}

export default router;
